/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AptosCoinDetailInfo } from '../models/AptosCoinDetailInfo';
import type { AptosCoinDetailRequest } from '../models/AptosCoinDetailRequest';
import type { AptosCoinHolderListInfo } from '../models/AptosCoinHolderListInfo';
import type { AptosCoinHolderListRequest } from '../models/AptosCoinHolderListRequest';
import type { AptosCoinListInfo } from '../models/AptosCoinListInfo';
import type { AptosCoinListRequest } from '../models/AptosCoinListRequest';
import type { AptosCoinMarketCapListInfo } from '../models/AptosCoinMarketCapListInfo';
import type { AptosCoinMarketCapListRequest } from '../models/AptosCoinMarketCapListRequest';
import type { AptosCoinMemeListRequest } from '../models/AptosCoinMemeListRequest';
import type { AptosCoinNewCoinListRequest } from '../models/AptosCoinNewCoinListRequest';
import type { AptosCoinNewListInfo } from '../models/AptosCoinNewListInfo';
import type { AptosCoinTopGainerListInfo } from '../models/AptosCoinTopGainerListInfo';
import type { AptosCoinTopGainerListRequest } from '../models/AptosCoinTopGainerListRequest';
import type { AptosCoinTopLoserListInfo } from '../models/AptosCoinTopLoserListInfo';
import type { AptosCoinTopLoserRequest } from '../models/AptosCoinTopLoserRequest';
import type { AptosCoinTransactionListRequest } from '../models/AptosCoinTransactionListRequest';
import type { AptosCoinTransferRequest } from '../models/AptosCoinTransferRequest';
import type { AptosMemeCoinListInfo } from '../models/AptosMemeCoinListInfo';
import type { AptosTrxListInfo } from '../models/AptosTrxListInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class CoinControllerService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinDetail({
        requestBody,
    }: {
        requestBody: AptosCoinDetailRequest,
    }): CancelablePromise<AptosCoinDetailInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinTransferList({
        requestBody,
    }: {
        requestBody: AptosCoinTransferRequest,
    }): CancelablePromise<AptosCoinTransferRequest> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/transfer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinTransactionList({
        requestBody,
    }: {
        requestBody: AptosCoinTransactionListRequest,
    }): CancelablePromise<AptosTrxListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/transaction/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getNewCoinList({
        requestBody,
    }: {
        requestBody: AptosCoinNewCoinListRequest,
    }): CancelablePromise<AptosCoinNewListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/new/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getMemeCoinList({
        requestBody,
    }: {
        requestBody: AptosCoinMemeListRequest,
    }): CancelablePromise<AptosMemeCoinListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/meme/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinMarketCapList({
        requestBody,
    }: {
        requestBody: AptosCoinMarketCapListRequest,
    }): CancelablePromise<AptosCoinMarketCapListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/marketcap/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTopLoserList({
        requestBody,
    }: {
        requestBody: AptosCoinTopLoserRequest,
    }): CancelablePromise<AptosCoinTopLoserListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/looser/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinList({
        requestBody,
    }: {
        requestBody: AptosCoinListRequest,
    }): CancelablePromise<AptosCoinListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getCoinHolderList({
        requestBody,
    }: {
        requestBody: AptosCoinHolderListRequest,
    }): CancelablePromise<AptosCoinHolderListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/holder/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public getTopGainerList({
        requestBody,
    }: {
        requestBody: AptosCoinTopGainerListRequest,
    }): CancelablePromise<AptosCoinTopGainerListInfo> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/coin/gainer/list',
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
